import FieldSet from '../../FieldSet';
import terminology from 'javascripts/terminology';

import { TeamIteration } from './TeamIteration';

export class IterationFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [TeamIteration];
  }

  get title() {
    return terminology('Iteration');
  }
}
